/**
 * Venue enum for the prevention-list application
 * Represents different locations where prevention measures can take place
 */
export enum Venue {
    Host = 'Eigene Räumlichkeiten',
    School = 'Schule',
}

/**
 * Determines the most likely venue enum value based on the input string
 *
 * @param venueString The venue string from the API
 * @returns The most likely Venue enum value
 */
export function determineVenueType(venueString: string): Venue {
    // Map common venue strings to our enum values
    if (venueString.includes('HOST')) {
        return Venue.Host;
    } else if (venueString.includes('SCHOOL')) {
        return Venue.School;
    }

    return Venue.Host;
}
